import React from 'react';
import { graphql } from 'gatsby';
import SEO from 'components/SEO';
import styled from 'styled-components';
import { Flex, Box, Container } from 'components/Grid';
import H1 from 'components/H1';
import H2 from 'components/H2';
import H3 from 'components/H3';
import Paragraph from 'components/Paragraph';
import Image from 'components/Image';
import Animate from 'components/Animate';
import css from '@styled-system/css';
import usePagination from 'utils/hooks/usePagination';
import chunk from 'utils/helpers/chunk';
import getSeo from 'utils/helpers/getSeo';
// images

const SingleNewsStyled = styled(Box)`
	word-break: break-word;
	hyphens: auto;
`;

const NewsPage = ({ data }) => {
	const { currentPage, handleSetPage, pageCount, items } = usePagination(data.posts.edges, 12);
	const gridItemsChunked = chunk(items, 12);
	const seo = getSeo(data.page);
	console.log(gridItemsChunked);

	return (
		<div>
			<SEO {...seo} keywords={[`nyheter`, `news`, `Senaste`]} />
			<Flex bg="client.accent">
				<Container>
					<Flex>
						<Box width={[1, 4 / 5]}>
							<Animate animateOnInView>
								<H1>{data.page.headline}</H1>
							</Animate>
						</Box>
					</Flex>
				</Container>
			</Flex>
			<Container mt={['-8rem', '-6rem', '-11rem']}>
				<Flex
					grid
					gridGap={[6, 4]}
					gridTemplateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)']}
				>
					{gridItemsChunked[0].map(item => (
						<SingleNewsStyled
							minHeight="500px"
							width="100%"
							key={item.node.id}
							as="a"
							href={`/nyheter/${item.node.slug}`}
							cursor="pointer"
							css={css({
								'&:hover h2': {
									color: 'client.darkBlue'
								}
							})}
						>
							{item.node.featuredImage ? (
								<Image
									height="400px"
									durationFadeIn={100}
									mb={[2]}
									fluid={{ ...item.node.featuredImage.fluid, aspectRatio: 0.7 }}
								/>
							) : (
								<Box mb={[2]} bg={'client.primary'} height="400px"></Box>
							)}
							<Paragraph mb={[2]}> {item.node.type} </Paragraph>
							<H3 mb={2} color="client.primary" lineHeight="1.2">
								{item.node.headline}
							</H3>
							<Paragraph m={0}> {item.node.optionalDate || item.node.createdAt} </Paragraph>
						</SingleNewsStyled>
					))}
				</Flex>
			</Container>
			{currentPage < pageCount && (
				<Container pt={[0, 0]} pb={[5, 5, 7]} cursor="hourglass" onClick={handleSetPage}>
					<Flex alignItems="center" justifyContent="center">
						<Box textAlign="center">
							<H2 mb={0} color="client.primary">
								Ladda fler nyheter
							</H2>
						</Box>
					</Flex>
				</Container>
			)}
		</div>
	);
};

export const query = graphql`
	query {
		posts: allContentfulPost(sort: { fields: [optionalDate, createdAt], order: DESC }) {
			edges {
				node {
					id
					featuredImage {
						fluid {
							...GatsbyContentfulFluid
						}
					}
					slug
					headline
					createdAt(formatString: "d MMMM YYYY", locale: "sv")
					optionalDate(formatString: "d MMMM YYYY", locale: "sv")
					type
				}
			}
		}
		page: contentfulPageNews {
			headline
			seo {
				ogText
				ogDescription
				ogImage {
					file {
						url
					}
				}
			}
		}
	}
`;

export default NewsPage;
